import React from 'react';
import {connect} from 'react-redux';

import Button from '~/components/common/Button';
import {modalClose} from '~/modules/modal/actions';
import mapDispatch from '~/misc/mapDispatch';

import css from './index.css';
import config from './config.js';

const RateUpdate = (props) => {
  const txt = config[props.context];
  return (
    <div className={css.popwrap}>

      <h1 className={css.header}> {txt.header} </h1>

      {txt.body
        ? (<div className={css.container}>{
          txt.body.map((item, index) => {
            if (typeof item === typeof []) {
              return (
                <ul className={css.ulPadding} key={index}>
                  {item.map((list, num) => <li className={css.liPadding} key={num}>{list}</li>)}
                </ul>
              );
            }
            return (<div key={index} className={css.centerTxt}>{item}</div>);
          })
        }</div>)
        : null
      }
      
      <div className={css.footer}>
        <div className={css.btnWrap}>
          <Button mods={['tall', 'strench', 'wide']} onClick={props.closePop}>
            {txt.btnTXT}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default connect(null, mapDispatch({
  closePop: (props, e) => {
    e.preventDefault();
    return modalClose(props.uri);
  },
}))(RateUpdate);




// WEBPACK FOOTER //
// ./src/components/rate/RateUpdate/index.js